import $axios from '@/axios-instance.js'

export const workOrderService = {
  getListData,
  getById,
  getEmptyWorkOrder,
  create,
  createWorkOrdersFromDeliveryTemplate,
  setWorkOrderStatusForList,
  exportToExcel,
  containsStatusStarted,
  update,
  delete: _delete
}

// function getListData (filter, page) {
//   return $axios.get(`${process.env.ROOT_API}/work-orders`, { params: Object.assign({ currentPage: page, type: 'WorkOrders' }, filter) }).then(response => {
//     return response.data
//   })
// }

function getListData (filter, page) {
  let fixedFilter = Object.assign({ currentPage: page, type: 'WorkOrders' }, filter)
  let statuses = (fixedFilter.statuses && fixedFilter.statuses) ? fixedFilter.statuses.map(x => x.value) : null
  fixedFilter.statuses = statuses

  return $axios.post(`${process.env.ROOT_API}/work-orders/list`, Object.assign({ currentPage: page }, fixedFilter)
  ).then(response => {
    return response.data
  })
}

function getById (id) {
  return $axios.get(`${process.env.ROOT_API}/work-orders/${id}`).then(response => {
    return response.data
  })
}

function getEmptyWorkOrder (projectCode) {
  return $axios.get(`${process.env.ROOT_API}/work-orders/get-empty-work-order/${projectCode}`).then(response => {
    return response.data
  })
}

function createWorkOrdersFromDeliveryTemplate (data) {
  return $axios.post(`${process.env.ROOT_API}/work-orders/create-from-delivery-template`, data).then(response => {
    return response.data
  })
}

function setWorkOrderStatusForList (data) {
  return $axios.post(`${process.env.ROOT_API}/work-orders/set-work-order-status-for-list`, data).then(response => {
    return response.data
  })
}

function exportToExcel (filter, template) {
  var config = {
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
    responseType: 'blob'
  }

  const url = `${process.env.ROOT_API}/work-orders/export-${template}-to-excel`
  return $axios.post(url, filter, config)
    .then((response) => {
      return response
    })
}

function containsStatusStarted (projectId) {
  return $axios.get(`${process.env.ROOT_API}/work-orders/contains-status-started/${projectId}`).then(response => {
    return response.data
  })
}

function create (workOrder) {
  return $axios.post(`${process.env.ROOT_API}/work-orders`, workOrder).then(response => {
    return response.data
  })
}

function update (workOrder) {
  return $axios.put(`${process.env.ROOT_API}/work-orders/${workOrder.workOrderId}`, workOrder).then(response => {
    return response.data
  })
}

function _delete (id) {
  return $axios.delete(`${process.env.ROOT_API}/work-orders/${id}`).then(response => {
    return response.data
  })
}



// WEBPACK FOOTER //
// ./src/services/work-order.service.js